import { getCDNUrl } from '../../services/Config';

// Accept type : Personnalisation
export const generateManifest = (personnalisation) => {
  const personnalisationId = personnalisation.id.toString();
  const themeColorMain = personnalisation.theme.hexaCouleurTheme1;
  const base_url = window.location.origin;
  const cdn_url = getCDNUrl();

  return {
    name: 'Carte Privilège',
    short_name: 'Carte Privilège',
    id: base_url,
    start_url: "./accueil",
    scope: base_url,
    icons: [
      {
        src: cdn_url + personnalisationId + '/favicon.ico',
        sizes: '64x64 32x32 24x24 16x16',
        type: 'image/x-icon',
        purpose: "any maskable"
      },
      {
        src: cdn_url + personnalisationId + '/logo192.png',
        type: 'image/png',
        sizes: '192x192',
      },
      {
        src: cdn_url + personnalisationId + '/logo512.png',
        type: 'image/png',
        sizes: '512x512',
      },
    ],
    background_color: '#ffffff',
    display: 'standalone',
    theme_color: themeColorMain,
    description: 'Carte Privilège pour les particuliers #' + personnalisationId,
  };
};

// // Accept type : PersonnalisationClient
// export const addManifest = (personnalisation) => {
//   const cdn_url = getCDNUrl();
//   let manifestLink = document.getElementById('react-app-manifest');
//   let themeLink = document.getElementById('theme-color');
//   if (cdn_url && personnalisation.personnalisation) {
//     const personnalisationId = personnalisation.personnalisation.id.toString();
//     // const manifest = generateManifest(personnalisation.personnalisation);
//     // let content = encodeURIComponent(JSON.stringify(manifest));
//     // let url = 'data:application/manifest+json,' + content;
//     manifestLink?.setAttribute('href', ''+cdn_url+personnalisationId+'/manifest.webmanifest');
//     // change theme-color value
//     themeLink?.setAttribute('content', ''+personnalisation.personnalisation.theme.hexaCouleurTheme1);
//   } else {
//     manifestLink?.setAttribute('href', '/manifest.json');
//     themeLink?.setAttribute('content', ''+redLight);
//   }
//   // themeLink?.removeAttribute('content');
// };

// Accept type : PersonnalisationClient
export const addManifest = (personnalisation) => {
  let manifestLink = document.getElementById('react-app-manifest');
  let themeLink = document.getElementById('theme-color');
  let themeLinkIos = document.getElementById('theme-color-ios');
  if (personnalisation.personnalisation) {
    const manifest = generateManifest(personnalisation.personnalisation);
    let content = encodeURIComponent(JSON.stringify(manifest));
    let url = 'data:application/manifest+json,' + content;
    manifestLink?.setAttribute('href', url);
    // change theme-color value
    themeLink?.setAttribute('content', personnalisation.personnalisation.theme.hexaCouleurTheme1);
    themeLinkIos?.setAttribute('content', personnalisation.personnalisation.theme.hexaCouleurTheme1);
  } else {
    manifestLink?.setAttribute('href', '/manifest.json');
  }
  // themeLink?.removeAttribute('content');
};

// // Accept type : PersonnalisationClient
// export const addManifest = (personnalisation) => {
//   let manifestLink = document.getElementById('react-app-manifest');
//   if (personnalisation.personnalisation) {
//     const manifest = generateManifest(personnalisation.personnalisation);
//     let content = encodeURIComponent(JSON.stringify(manifest));
//     let url = 'data:application/manifest+json,' + content;
//     manifestLink?.setAttribute('href', url);
//   } else {
//     manifestLink?.setAttribute('href', '/manifest.json');
//   }
// };

// Accept type : number, personnalisationId
export const addLinkUrl = (personnalisationId, cdn_url) => {

  const iconList = ['icon', 'apple-touch-icon'];

  iconList.forEach((id) => {
    let link = document.getElementById(id);
    let url;
    if (personnalisationId) {
      url = cdn_url + personnalisationId.toString() + '/logo512.png';
    } else {
      url = process.env.PUBLIC_URL + '/logo512.png';
    }
    link?.setAttribute('href', url);
  });

  let linkTitle = document.getElementById('title');
  linkTitle?.setAttribute('content', 'Carte Privilège');

  let linkDescription = document.getElementById('description');
  linkDescription?.setAttribute('content', 'Carte Privilège');

  // let link = document.getElementById('apple-touch-icon');
  // let url;
  // if (personnalisationId) {
  //   url = cdn_url + personnalisationId.toString() + '/logo512.png';
  // } else {
  //   url = process.env.PUBLIC_URL + '/logo192.png';
  // }
  // link.setAttribute('href', url);

  // let link2 = document.getElementById('icon');
  // let url2;
  // if (personnalisationId) {
  //   url2 = cdn_url + personnalisationId.toString() + '/logo512.png';
  // } else {
  //   url2 = process.env.PUBLIC_URL + '/logo192.png';
  // }
  // link2.setAttribute('href', url2);


};

// // Accept type : number, personnalisationId
// export const addLinkUrl = (personnalisationId) => {
//   const cdn_url = getCDNUrl();
//   const list = [
//     'icon-192',
//     'apple-touch-icon',
//     'apple-touch-icon-152',
//     'apple-touch-icon-167',
//     'apple-touch-icon-180',
//     'mask-icon',
//   ];
//   list.forEach((id) => {
//     let link = document.getElementById(id);
//     let url = '';
//     if (personnalisationId) {
//        url = cdn_url + personnalisationId.toString() + '/logo192.png';
//     }
//     else {
//       url = '/logo192.png';
//     }
//     link.setAttribute('href', url);
//   });
// };
